import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import Profile from '../components/Profile';
import Packages from '../components/Packages';
import Advices from '../components/Advices';
import Contact from '../components/Contact';
import CompanyTicker from '../components/CompanyTicker';

const MainPage = () => {
  return (
    <div className="bg-white">
      <Navbar />
      <section id="hero">
        <Hero />
      </section>
      <section id="profile">
        <Profile />
      </section>
      <CompanyTicker />
      <section id="packages">
        <Packages />
      </section>
      <section id="advices">
        <Advices />
      </section>
      <section id="contact">
        <Contact />
      </section>
      <Footer />
    </div>
  );
};

export default MainPage;
